import { http } from '../api/http';
import type { PaymentSettings } from '../types/PaymentSettings';

export const PaymentsService = {
  getAdminPaymentSettings() {
    return http<PaymentSettings>('/admin/payment-settings');
  },

  updateAdminPaymentSettings(payload: PaymentSettings) {
    return http<PaymentSettings>('/admin/payment-settings', {
      method: 'PUT',
      body: payload
    });
  }
};
